const colors: string[] = [
  "#FAEBD7", // Antique White
  "#F0FFFF", // Azure
  "#E0FFFF", // Light Cyan
  "#FFF5EE", // Sea Shell
  "#F5FFFA", // Mint Cream
  "#FFE4E1", // Misty Rose
  "#FFF0F5", // Lavender Blush
  "#F0FFF0", // Honeydew
  "#FFF8DC", // Cornsilk
  "#F5F5DC", // Beige
];

export const pickRandomColor = () => {
  return colors[Math.floor(Math.random() * colors.length)];
};
